// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__2MSNS","dragIcon":"Choice_dragIcon__3v9nH","left":"Choice_left__2srSM","input":"Choice_input__BYDs4"};